'use strict';
var customSwal = require('../utils/customSwal');

function multiplePurchaseModal () {
	$(document).on('click', '.product-multiple-purchase-icon', function (e) {
		e.preventDefault();
        e.stopPropagation();
		var triggerBtn = e.target;
		var wrap = triggerBtn.closest('.product-multiple-purchase-disclaimer-container').parentElement;
		var panelRoot = wrap.querySelector('.multiple-purchase-modal-panel');
		var returnSlot = document.createElement('span');
		returnSlot.hidden = true;
		wrap.insertBefore(returnSlot, panelRoot);
		panelRoot.hidden = false;

		var mobile = typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 767.98px)').matches;

		var opts = {
			html: panelRoot,
			didOpen: function () {
				document.documentElement.classList.add('no-overflow');
				if (typeof window.$ !== 'undefined' && window.$) {
					window.$('body').trigger('swal:open');
				}
				triggerBtn.setAttribute('aria-expanded', 'true');
			},
			didClose: function () {
				document.documentElement.classList.remove('no-overflow');
				if (typeof window.$ !== 'undefined' && window.$) {
					window.$('body').trigger('swal:close');
				}
				if (returnSlot && returnSlot.parentNode && panelRoot) {
					panelRoot.hidden = true;
					returnSlot.parentNode.insertBefore(panelRoot, returnSlot);
					returnSlot.parentNode.removeChild(returnSlot);
				}
				triggerBtn.setAttribute('aria-expanded', 'false');
			},
			customClass: {
				container: 'sa-right-panel-container sa-multiple-purchase',
				popup: 'sa-right-panel-popup sa-multiple-purchase__popup',
				htmlContainer: 'sa-right-panel-html sa-multiple-purchase__html',
			}
		};

		if (mobile) {
			Object.assign(opts, {
				position: 'bottom',
				grow: 'row',
				width: '100%',
				showClass: {
					popup: 'sa2-slide-up-in sa2-anim-faster',
				},
				hideClass: {
					popup: 'sa2-slide-down-out sa2-anim-faster',
				}
			});
		}

		customSwal.Swal.fire(customSwal.rightPanelOptions(opts));
	});
}

module.exports = function initMultiplePurchase() {
    multiplePurchaseModal();
};

module.exports.multiplePurchaseModal = multiplePurchaseModal;